// extracted by mini-css-extract-plugin
module.exports = {"container":"e_br","image":"e_cr","imageImage":"e_dr","description":"e_er","title":"e_fr","button":"e_gr"};